// arrivalDate represents a banking calendar date, not a local event timestamp.
export function formatBankDate(value: string | null): string {
  return value
    ? new Date(value).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
    : 'Previsão indisponível'
}
